import { Answer, Translatable } from '../state/interfaces'
import { uniqBy } from 'lodash'
import { selectPhones } from '../state'
import { AnswersProvider } from './interfaces'

export const phoneBrandsProvider: AnswersProvider = async (state, options) => {
  let phones = selectPhones(state)

  if (options?.os) {
    phones = phones.filter((phone) => phone.osSlug === options.os)
  }

  const answers = phones.map<Answer>((phone) => ({
    id: phone.brandSlug,
    text: phone.brandName as Translatable,
  }))

  answers.unshift({ id: 'all', text: 'common_all' })

  return uniqBy(answers, (a) => a.text)
}
